import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionsSubject, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';

import { CheckOwner, CheckType } from 'src/app/shared/models/autogenerated';
import {
  selectAllPhases,
  selectBusinessUnitForm,
} from '../../store/global-settings.selectors';
import {
  clearBusinessUnitForm,
  createBusinessUnitFromForm,
  createBusinessUnitFromFormSuccess,
  loadAllPhases,
  loadBusinessUnit,
  updateBusinessUnitForm,
  updateBusinessUnitFormSuccess,
} from '../../store/global-settings.actions';
import {
  CHECK_TYPE_MAX_LENGTH,
  DELIVERABLE_KEYWORDS_MAX_LENGTH,
  SCOPE_OF_REVIEW_MAX_LENGTH,
} from '../../../checks/checks.constants';

@Component({
  standalone: false,
  selector: 'app-business-unit-form-dialog',
  templateUrl: './business-unit-form-dialog.component.html',
  styleUrls: ['./business-unit-form-dialog.component.scss'],
})
export class BusinessUnitDialogFormComponent implements OnDestroy {
  @Output() saved = new EventEmitter();
  formState$ = this.store.select(selectBusinessUnitForm);
  allPhases$ = this.store.select(selectAllPhases);
  private readonly subscriptions = new Subscription();

  readonly CHECK_TYPES_VALUES = Object.values(CheckType);
  readonly CHECK_TYPES = CheckType;
  readonly CHECK_OWNER = CheckOwner;

  readonly SCOPE_OF_REVIEW_MAX_LENGTH = SCOPE_OF_REVIEW_MAX_LENGTH;
  readonly DELIVERABLE_KEYWORDS_MAX_LENGTH = DELIVERABLE_KEYWORDS_MAX_LENGTH;
  readonly CHECK_TYPE_MAX_LENGTH = CHECK_TYPE_MAX_LENGTH;
  readonly REGION_MAX_LENGTH = 200;

  readonly businessUnitId?: string;
  readonly title: string;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<BusinessUnitDialogFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private actionsSubject$: ActionsSubject
  ) {
    this.store.dispatch(loadAllPhases());
    this.businessUnitId = data;
    if (this.businessUnitId) {
      this.store.dispatch(
        loadBusinessUnit({
          businessUnitId: this.businessUnitId,
        })
      );
      this.title = 'edit business unit';
    } else {
      this.store.dispatch(clearBusinessUnitForm());
      this.title = 'add business unit';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeWindow(): void {
    this.dialogRef.close();
  }

  save() {
    this.businessUnitId ? this.update() : this.create();
  }

  private update() {
    this.registerActionSuccess(updateBusinessUnitFormSuccess.type);
    this.store.dispatch(
      updateBusinessUnitForm({
        businessUnitId: this.businessUnitId!,
      })
    );
  }

  private create() {
    this.registerActionSuccess(createBusinessUnitFromFormSuccess.type);
    this.store.dispatch(createBusinessUnitFromForm());
  }

  unsorted(a: any, b: any): number {
    return 0;
  }

  private registerActionSuccess(actionType: string) {
    this.subscriptions.add(
      this.actionsSubject$
        .pipe(filter((action) => action.type === actionType))
        .subscribe(() => {
          this.dialogRef.close();
        })
    );
  }
}
